import { useTranslation } from 'react-i18next';
import { DateFormatter } from 'infrastructure/functions';
import { useMemo, type FC } from 'react';

import s from '../style.module.scss';

import type { InteractiveTimeItem } from 'infrastructure/hooks/interactiveTimeDashboard/types';

interface Props {
  record: InteractiveTimeItem;
}

export const InteractionFlag: FC<Props> = ({ record }) => {
  const { t } = useTranslation();

  const label = useMemo(() => {
    if (record.patientInteractionStatus !== true) {
      return t('interactiveTimeDashboard.false');
    }

    return record.lastInteractionStatusChangedByUserType === 'practice'
      ? t('interactiveTimeDashboard.trueByClinic')
      : t('interactiveTimeDashboard.true');
  }, [record]);

  return (
    <div
      className={s.interactionStatus}
      data-cy="interactiveTimeDashboard-interactionFlag"
    >
      {label}
      {record.lastInteractionStatusChange && (
        <span className={s.date}>
          {t('labels.lastInteraction')}: <br />
          {DateFormatter({ date: record.lastInteractionStatusChange })}
        </span>
      )}
    </div>
  );
};
